export default __webpack_public_path__ + "static/AppMoneyWalkie13-595c5a824684ef06c3a50ff4517d56fc.png";